import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { colors, customEvent, HStack } from "goi_common";
import { useRouter } from "next/router";

interface GuidebookInquiryProps {
  id: number;
  author: string;
  content: string;
  status: "답변 대기 중" | "답변 완료";
  tags: string[];
  keyword?: string;
  onClick?: () => void;
}

export function GuidebookInquiry({
  id,
  author,
  content,
  status,
  tags,
  keyword,
  onClick,
}: GuidebookInquiryProps) {
  const router = useRouter();
  const isDone = status === "답변 완료";

  return (
    <InquiryRoot
      onClick={() => {
        customEvent({
          newGtm: {
            path: router.asPath.includes("guidebook/search")
              ? "guidebook_search"
              : router.asPath.includes("guidebook")
              ? "guidebook"
              : "my_detail",
            trigger_and_target: "qna_detail_card-open_qna_modal",
          },
        });
        onClick
          ? onClick()
          : router.push({ pathname: router.pathname, query: { ...router.query, id } }, undefined, {
              scroll: false,
            });
      }}
    >
      <Box marginBottom="12px" className="button2 black" fontWeight={700}>
        Q. {author}님의 질문
      </Box>
      <Content
        className="body2 gray900"
        dangerouslySetInnerHTML={{
          __html: keyword
            ? content.replaceAll(keyword, `<span class="orange650">${keyword}</span>`)
            : content,
        }}
      />
      <HStack justifyContent="space-between" alignItems="center">
        <Box
          bgColor={isDone ? colors.orange100 : colors.green50}
          padding="8px 12px"
          borderRadius="5px"
          color={isDone ? colors.orange650 : colors.green450}
          className="caption1"
        >
          {status}
        </Box>
        <HStack gap={16}>
          {tags.map((tag) => {
            return (
              <Box key={tag} className="caption1 gray500">
                #{tag}
              </Box>
            );
          })}
        </HStack>
      </HStack>
    </InquiryRoot>
  );
}

const InquiryRoot = styled.div`
  border: 1px solid #f5f5f5;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
  border-radius: 0px 20px 20px 20px;
  padding: 24px 20px;
  cursor: pointer;
`;
const Content = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  margin-bottom: 40px;
  white-space: pre-wrap;
`;
